import { ArrowUpRight } from "lucide-react";
import { StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionTitle } from "@/components/Shared";
import { PRESS } from "@/data/site";

export const PressSection = ({ bg = "bg-[#050505]" }) => {
  return (
    <section data-testid="press-section" className={`relative py-24 md:py-32 ${bg}`}>
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionTitle eyebrow="IN THE NEWS" title="Featured & Recognised" className="mb-14" />
        <StaggerGroup className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PRESS.map((p, i) => (
            <StaggerItem key={i}>
              <a
                href={p.href}
                target="_blank"
                rel="noreferrer"
                data-testid={`press-card-${i}`}
                className="group flex h-full flex-col overflow-hidden rounded-xl border border-white/10 bg-obsidian transition-all hover:-translate-y-2 hover:border-kbcyan/50"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent opacity-80" />
                  <span className="absolute left-4 top-4 rounded-full bg-black/70 px-3 py-1 text-xs font-semibold tracking-wide text-kbcyan backdrop-blur-md">
                    {p.source}
                  </span>
                  <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-kbyellow text-black opacity-0 transition-opacity group-hover:opacity-100">
                    <ArrowUpRight className="h-5 w-5" />
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <span className="font-display text-sm tracking-[0.25em] text-white/40">{p.date}</span>
                  <h3 className="mt-2 font-display text-xl leading-tight tracking-wide text-white transition-colors group-hover:text-kbcyan">
                    {p.title}
                  </h3>
                  <div className="mt-auto pt-5">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-kbyellow">
                      Read the article
                      <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </div>
              </a>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default PressSection;
